import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Star,
  Build,
} from "@mui/icons-material";
import Slider from "react-slick";
import ContactForm from "./model-form"; // <-- Separate Modal Component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CarouselSection = () => {
  const [openModal, setOpenModal] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const carouselImages = [
    "https://i.ibb.co/HLCVX23p/1.png",
    "https://i.ibb.co/5gW1dD9s/2.png",
    "https://i.ibb.co/PG3TLr9Q/3.png",
    "https://i.ibb.co/LDrNPRG3/4.png",
  ];

  useEffect(() => {
    let loaded = 0;
    carouselImages.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = img.onerror = () => {
        loaded++;
        if (loaded === carouselImages.length) {
          setImagesLoaded(true);
        }
      };
    });
  }, []);

  

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    appendDots: dots => (
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <ul style={{ padding: 0, margin: 0 }}>{dots}</ul>
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          background: "orangered",
          display: "inline-block",
        }}
      />
    ),
  };

  return (
    <>
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="center"
        sx={{ px: { xs: 2, md: 8 }, py: 6 }}
      >
        {/* Text & Button */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
          >
            <span style={{ color: "orangered" }}>Go Clutch</span>: Car Service Simplified
          </Typography>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{ color: "#444", mb: 3 }}
          >
            <strong style={{ color: "orangered" }}>INR 1000 OFF</strong> on All Car Services
          </Typography>
          <Box textAlign="center">
            <Button
              variant="contained"
              onClick={() => setOpenModal(true)}
              sx={{
                background: "linear-gradient(to right, orangered, orange)",
                color: "white",
                fontWeight: "bold",
                px: 4,
                py: 1.5,
                borderRadius: "30px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                '&:hover': {
                  background: "linear-gradient(to right, #ff5722, #ff9800)"
                }
              }}
            >
              BOOK NOW
            </Button>
          </Box>

          <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Star sx={{ color: "#FFC107" }} />
              <Typography fontWeight="bold">4.5+ Rated Garages</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Build sx={{ color: "orangered" }} />
              <Typography fontWeight="bold">
                <span style={{ color: "orangered" }}>Go Clutch</span> Mechanics
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Carousel */}
        <Grid item xs={12} md={8}>
          {imagesLoaded ? (
            <Slider {...settings}>
              {carouselImages.map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    px: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={image}
                    alt={`slide-${index}`}
                    sx={{
                      width: "100%",
                      maxHeight: 500,
                      borderRadius: 3,
                      objectFit: "cover",
                    }}
                  />
                </Box>
              ))}
            </Slider>
          ) : (
            <Box sx={{ height: 300, textAlign: "center", pt: 10 }}>
              Loading...
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Form Modal */}
      <ContactForm open={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};

export default CarouselSection;
